import { User } from './user-state.model';

export enum ActionTypes {
  StoreUser = '[StoreUser] action',
  ResetUser = '[ResetUser] action'
}
export class StoreUserAction {
  public static readonly type = ActionTypes.StoreUser;
  constructor(public payload: User, public isLoadedSuccessfully: boolean) { }
}

export class ResetUserAction {
  public static readonly type = ActionTypes.ResetUser;
  constructor() { }
}
